import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { ClipboardCheck } from "lucide-react";
import { toast } from "sonner";

// Users & Roles card for PUT /pdi-reports/settings (admin): tick the roles
// that may view and edit PDI Reports on Delivery Challans. Admin always can.
export default function PdiPermissionSettings() {
  const [available, setAvailable] = useState([]);
  const [roles, setRoles] = useState([]);
  const [saved, setSaved] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/pdi-reports/settings").then(({ data }) => {
      setAvailable(data.available_roles);
      setRoles(data.roles);
      setSaved(data.roles);
    }).catch(() => {});
  }, []);

  const toggle = (code, on) => setRoles((rs) => (on ? [...rs, code] : rs.filter((r) => r !== code)));
  const dirty = roles.length !== saved.length || roles.some((r) => !saved.includes(r));

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/pdi-reports/settings", { roles });
      setRoles(data.roles);
      setSaved(data.roles);
      toast.success("PDI Report permission saved");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Save failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-white border border-slate-200 rounded-lg p-6" data-testid="pdi-permission-settings">
      <div className="flex items-center gap-2 mb-1">
        <ClipboardCheck className="w-5 h-5 text-emerald-600" />
        <h3 className="font-semibold text-slate-900">PDI Report permission</h3>
      </div>
      <p className="text-sm text-slate-500">
        Roles ticked here see the PDI Report button on Delivery Challans and can view, fill in and approve PDI Reports.
        Administrators always have access.
      </p>
      <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2">
        {available.map((r) => (
          <label key={r.code} className="flex items-center gap-2 text-sm text-slate-700 cursor-pointer">
            <Checkbox checked={roles.includes(r.code)} onCheckedChange={(v) => toggle(r.code, !!v)} data-testid={`pdi-role-${r.code}`} />
            {r.label}
          </label>
        ))}
      </div>
      <div className="mt-4">
        <Button onClick={save} disabled={busy || !dirty} className="bg-blue-600 hover:bg-blue-700" data-testid="pdi-permission-save">
          {busy ? "Saving…" : "Save"}
        </Button>
      </div>
    </div>
  );
}
